<app-scotty-spinner [text]="text | translate"></app-scotty-spinner>
<div class="background"></div>
